export default __webpack_public_path__ + "static/img-groupers-500x325-43cce89e2159ae720ba3fd9570f7a5d9.png";